import { baseTheme } from "./recipes";

import "./recipes/assets/styles/reset.css";
import "./recipes/assets/styles/index.css";

export default {
  ...baseTheme
};
